import { LoyaltyStatusSource } from "@/api/orval/model";

/** The API sends how a status was given as a number; the names mirror `LoyaltyService.Contract/Enums`. */
export const StatusSource = {
  Earned: LoyaltyStatusSource.NUMBER_0,
  GrantedByStaff: LoyaltyStatusSource.NUMBER_1,
  Backfilled: LoyaltyStatusSource.NUMBER_2,
} as const;
